import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Logo } from './logo';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    justifyContent: 'center'
  },
  logoText: {
    ...theme.typography.h6,
    marginLeft: 5
  }
});

class AppAppBar extends Component {
  render() {
    const { classes } = this.props;

    return (
      <AppBar position="static" color="default" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
            <Logo/>
            <span className={classes.logoText}>KS Ultralight Packbuilder</span>
        </Toolbar>
      </AppBar>
    )
  }
} 

export default withStyles(styles)(AppAppBar);